// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7ed844e2] .tooltip-inner{white-space:normal}#usename_1[data-v-7ed844e2]{display:inline-block;border-radius:50%;padding:2px;background-color:var(--topMenuFont);border:2px solid var(--topMenuFont);color:var(--topMenuBackground);cursor:pointer}#usename_1 .b-icon.bi[data-v-7ed844e2]{display:block}#usename_1[data-v-7ed844e2]:hover{background-color:var(--linkFontActive);border:2px solid var(--linkFontActive);color:var(--topMenuFont)}", ""]);
// Exports
module.exports = exports;
